export const FOM_KATEGORIEN = [
  'VorzeitigesTicketing',
  'FlugplanaenderungAbsprache',
  'VorabpruefungTicketBeiGruppe',
  'TicketfreigabeYield',
  'TicketRefund',
  'GruppeTicketing',
  'SpecialServices',
  'NegoQuotieren',
  'Individualisierung',
  'Flugbuchung',
  'InlandsflugBuchung',
  'InlandsflugPruefung',
  'InlandsflugAbsprache',
  'Flugpruefung',
  'TicketingAnfrage',
  'SegmenteMismatch',
  'UnverbindlichesFlugangebot',
];

export const FLUGEINKAUF_KATEGORIEN = [
  'PruefungThVkReduktion',
  'PruefungBackupGruppeAnlegen',
  'ThAufGruppenniveauAnheben',
  'ThVkMaxGkuePruefen',
  'FlugstammAnpassung',
];
